import * as React from "react"
const SvgOpenEmailEmpty = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13.025 2.314 8.025 4.8q.45.276.7.75.25.475.25 1v10.85a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19.714V8.864q0-.525.25-1 .25-.474.7-.75l8.025-4.8A2 2 0 0 1 12 2.04q.55 0 1.025.275ZM12 13.364l7.8-4.65-7.8-4.65-7.8 4.65zm-1.025 1.725L4 10.914v8.8h16v-8.8l-6.975 4.175a2 2 0 0 1-1.025.275q-.55 0-1.025-.275" />
  </svg>
)
export default SvgOpenEmailEmpty
